import { DescriptionField } from '../../../desktop/TicketDetailsPopup/TicketInfo/DescriptionField/DescriptionField';
import { TicketInfoField } from '../../../desktop/TicketDetailsPopup/TicketInfo/TicketInfoField/TicketInfoField';
import { TypeField } from '../../../desktop/TicketDetailsPopup/TicketInfo/TypeField/TypeField';
import {
  TicketInfoContentWrapper,
  TicketInfoWrapper,
} from './DetailsTab.styled';
import {
  ticketTypeLookUp,
  ticketCategoryLookUp,
  ticketPriorityLookUp,
} from 'src/components/Tickets/MyTickets.constants';
import { ApprovalField } from '../../../desktop/TicketDetailsPopup/TicketInfo/ApprovalField/ApprovalField';
import { OwnerField } from '../../../desktop/TicketDetailsPopup/TicketInfo/OwnerField/OwnerField';
import { StatusField } from '../../../desktop/TicketDetailsPopup/TicketInfo/StatusField/StatusField';
import { useGetTicketInfo } from 'src/components/Tickets/hooks/useGetTicketInfo';
import { CreatedOnField } from '../../../desktop/TicketDetailsPopup/TicketInfo/CreatedOnField/CreatedOnField';
import { RequestedDueDateField } from '../../../desktop/TicketDetailsPopup/TicketInfo/RequestDueDateField/RequestedDueDateField';
import { useServiceDeskContext } from 'src/context/ServiceDesk/ServiceDeskContext';
import { LoadingSpinner } from 'src/components/common/LoadingSpinner/LoadingSpinner';

export const DetailsTab = () => {
  const { viewTicketId } = useServiceDeskContext();
  const { formattedTicketData, loadingTicket } = useGetTicketInfo(viewTicketId);

  if (loadingTicket) {
    return (
      <TicketInfoWrapper>
        <LoadingSpinner />
      </TicketInfoWrapper>
    );
  }

  return (
    <TicketInfoWrapper>
      <TicketInfoContentWrapper>
        <TicketInfoField
          labelText="Ticket ID"
          displayValue={formattedTicketData?.new_id}
        />
        <CreatedOnField date={formattedTicketData?.createdon} />
        <RequestedDueDateField
          date={formattedTicketData?.new_requestedduedate}
        />
        <DescriptionField displayValue={formattedTicketData?.new_description} />
        <TypeField
          ticketType={
            ticketTypeLookUp[formattedTicketData?.new_tickettype]?.label
          }
          icon={ticketTypeLookUp[formattedTicketData?.new_tickettype]?.icon}
        />
        <TicketInfoField
          labelText="Category"
          displayValue={
            ticketCategoryLookUp[formattedTicketData?._new_category_value]
              ?.label
          }
        />
        <TicketInfoField
          labelText="Priority"
          displayValue={
            ticketPriorityLookUp[formattedTicketData?.new_priority]?.label
          }
        />
        <ApprovalField approval={formattedTicketData?.new_approvalstatus} />
        <OwnerField owner={formattedTicketData?.owner} />
        <StatusField status={formattedTicketData?.statuscode} />
      </TicketInfoContentWrapper>
    </TicketInfoWrapper>
  );
};
